'use client';

import * as React from 'react';

import { cn } from '@/utils/cn';

const VisuallyHidden = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'absolute h-px w-px overflow-hidden border-0 p-0 whitespace-nowrap',
      'clip-path-inset-50 clip-rect-0-0-0-0',
      className
    )}
    style={{
      clip: 'rect(0 0 0 0)',
      clipPath: 'inset(50%)',
      height: '1px',
      overflow: 'hidden',
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: '1px'
    }}
    {...props}
  />
));

VisuallyHidden.displayName = 'VisuallyHidden';

export { VisuallyHidden };
